// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.toggle-info[data-v-164324a2] {\n  display: flex;\n  min-width: 48px;\n  padding: 2px;\n  border-radius: 10000px;\n  cursor: pointer;\n  transition: 0.3s ease all;\n  height: -moz-fit-content;\n  height: fit-content;\n}\n.circle-data[data-v-164324a2] {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  border-radius: 10000px;\n  background: #FFF;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
